var _rect, _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 250,
    viewBox: "0 0 172 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_454_4593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 156,
    height: 246
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2.5,
    width: 156,
    height: 245,
    fill: "url(#paint0_linear_454_4593)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_454_4593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.263 146.353L120.897 142.709C120.002 142.308 119.002 142.095 117.985 142.095H51.4194C50.4605 142.095 49.5133 142.283 48.6538 142.648L40.6028 146.049C25.752 144.388 14 131.334 14 115.318V44.781C14 27.6394 27.2488 13.7461 43.5964 13.7461H129.409C145.751 13.7461 159 27.6394 159 44.781V115.312C159 132.454 145.751 146.347 129.404 146.347H128.263V146.353Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4205 137.678C27.1961 137.678 14 123.954 14 107.094V36.8944C14 20.0345 27.2019 6.31055 43.4205 6.31055H129.58C145.804 6.31055 159 20.0345 159 36.8944V107.088C159 123.954 145.798 137.672 129.58 137.672H43.4205V137.678Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.628 39.9497C138.347 39.9497 142.173 36.1125 142.173 31.3791C142.173 26.6458 138.347 22.8086 133.628 22.8086C128.908 22.8086 125.082 26.6458 125.082 31.3791C125.082 36.1125 128.908 39.9497 133.628 39.9497Z",
    stroke: "#444444",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3138 28.5407C39.8937 28.5407 41.1744 27.2562 41.1744 25.6717C41.1744 24.0872 39.8937 22.8027 38.3138 22.8027C36.7339 22.8027 35.4531 24.0872 35.4531 25.6717C35.4531 27.2562 36.7339 28.5407 38.3138 28.5407Z",
    fill: "#3466E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3997 28.5407C50.9796 28.5407 52.2603 27.2562 52.2603 25.6717C52.2603 24.0872 50.9796 22.8027 49.3997 22.8027C47.8198 22.8027 46.5391 24.0872 46.5391 25.6717C46.5391 27.2562 47.8198 28.5407 49.3997 28.5407Z",
    fill: "#3466E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4856 28.5407C62.0655 28.5407 63.3463 27.2562 63.3463 25.6717C63.3463 24.0872 62.0655 22.8027 60.4856 22.8027C58.9057 22.8027 57.625 24.0872 57.625 25.6717C57.625 27.2562 58.9057 28.5407 60.4856 28.5407Z",
    fill: "#3466E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5755 28.5407C73.1554 28.5407 74.4361 27.2562 74.4361 25.6717C74.4361 24.0872 73.1554 22.8027 71.5755 22.8027C69.9956 22.8027 68.7148 24.0872 68.7148 25.6717C68.7148 27.2562 69.9956 28.5407 71.5755 28.5407Z",
    fill: "#3466E2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_4593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5586 247.597V187.156H68.3386V247.597",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5586 247.597V187.156H68.3386V247.597",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3103 193.909H65.591L63.6055 187.477H71.2958L69.3103 193.909Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9867 176.473H63.9195C63.5367 176.473 63.2305 176.157 63.2305 175.774V166.241C63.2305 165.996 63.4248 165.799 63.6663 165.799H71.2458C71.4872 165.799 71.6816 165.996 71.6816 166.241V175.774C71.6757 176.163 71.3636 176.473 70.9867 176.473Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3711 165.799V172.155",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5273 165.799V172.155",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.473 188.96H63.4224C61.6674 188.96 60.2422 187.749 60.2422 186.259V173.234C60.2422 172.683 60.7663 172.238 61.4142 172.238H73.4872C74.135 172.238 74.6591 172.683 74.6591 173.234V186.259C74.6533 187.749 73.2281 188.96 71.473 188.96Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.2969 199.193L99.95 203.233H106.476L107.111 199.193",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2969 199.193L99.95 203.233H106.476L107.111 199.193",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.129 254.476V203.234H105.284V254.476",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.129 254.476V203.234H105.284V254.476",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7734 165.5V191.254L99.2951 199.194H107.109L112.57 191.254V165.5H93.7734Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7734 181.664H112.57",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5352 181.663V172.377H107.149V181.663",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.516 168.133V179.524",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.906 168.133V179.524",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.305 168.133V179.524",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.695 168.133V179.524",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.094 168.133V179.524",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3203 181.58V168.133H111.117V181.58",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7734 177.225H112.637",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.364 183.133C107.364 185.128 105.562 187.761 103.342 187.761C101.123 187.761 99.3203 185.128 99.3203 183.133C99.3203 181.137 101.123 179.518 103.342 179.518C105.562 179.518 107.364 181.143 107.364 183.133Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5995 94.0191C72.4946 94.0191 73.2264 93.2912 73.2264 92.3875C73.2264 91.4898 72.5007 90.7559 71.5995 90.7559C70.7044 90.7559 69.9727 91.4837 69.9727 92.3875C69.9727 93.2852 70.7044 94.0191 71.5995 94.0191Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5121 99.6422C79.4617 95.8391 75.6999 95.5723 74.327 95.5723H72.1377H71.4482H70.0754L65.5637 109.96H64.5234V110.433H65.4125H67.4748L69.8032 103.002H71.3394H71.3515H71.3575H72.8211C72.9784 103.002 73.2021 103.015 73.4743 103.015L71.3515 103.002L72.8574 107.388H75.2463V107.382L76.6978 107.388L76.2986 108.322L76.728 108.51L77.2058 107.388L78.0162 105.477L78.0283 105.453L78.1432 105.186L74.3149 105.235L73.6739 103.021H73.6557C75.1495 103.015 77.7441 102.723 78.5121 99.6422ZM76.4014 99.4602C75.8329 101.08 73.5408 101.049 72.8634 101.049H71.9502H71.7083H70.4201L71.5994 97.216H73.6739C74.5871 97.216 77.1211 97.4162 76.4014 99.4602Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5495 110.286C78.9063 110.286 79.1966 109.995 79.1966 109.637C79.1966 109.279 78.9063 108.988 78.5495 108.988H75.9005H75.7009H75.5497V108.994C75.2171 109.019 74.957 109.298 74.957 109.637V114.283C74.957 114.641 75.2473 114.932 75.6042 114.932C75.6223 114.932 75.6344 114.926 75.6525 114.926C75.6707 114.926 75.6828 114.932 75.7009 114.932H78.5495C78.9063 114.932 79.1966 114.641 79.1966 114.283C79.1966 113.926 78.9063 113.634 78.5495 113.634H76.2452V112.67H78.2229C78.5797 112.67 78.87 112.379 78.87 112.021C78.87 111.663 78.5797 111.372 78.2229 111.372H76.2452V110.28H78.5495V110.286Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.999 110.286C104.356 110.286 104.646 109.995 104.646 109.637C104.646 109.279 104.356 108.988 103.999 108.988H101.241H101.15H101.017V108.994C100.678 109.013 100.406 109.292 100.406 109.637V114.283C100.406 114.641 100.697 114.932 101.053 114.932H101.15H101.277H103.999C104.356 114.932 104.646 114.641 104.646 114.283C104.646 113.926 104.356 113.634 103.999 113.634H101.694V112.67H103.672C104.029 112.67 104.319 112.379 104.319 112.021C104.319 111.663 104.029 111.372 103.672 111.372H101.694V110.28H103.999V110.286Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5516 108.994L83.5334 108.988H83.5093H83.4246H83.4185H80.7938H80.57H80.4128C80.0559 108.988 79.7656 109.279 79.7656 109.637V114.283C79.7656 114.641 80.0559 114.932 80.4128 114.932C80.7696 114.932 81.0599 114.641 81.0599 114.283V112.67H82.8682V114.283C82.8682 114.641 83.1585 114.932 83.5153 114.932C83.8721 114.932 84.1624 114.641 84.1624 114.283V109.637C84.1564 109.298 83.8842 109.019 83.5516 108.994ZM82.8621 111.378H81.0538V110.286H82.8621V111.378Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3404 113.64H85.9817V109.643C85.9817 109.285 85.6914 108.994 85.3346 108.994C84.9778 108.994 84.6875 109.285 84.6875 109.643V114.289C84.6875 114.647 84.9778 114.938 85.3346 114.938H85.4919H85.5705H88.3464C88.7033 114.938 88.9936 114.647 88.9936 114.289C88.9875 113.931 88.6972 113.64 88.3404 113.64Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0605 110.31C94.4174 110.31 94.7077 110.019 94.7077 109.661C94.7077 109.631 94.7016 109.601 94.7016 109.57C94.7016 109.564 94.7016 109.564 94.6956 109.558C94.6774 109.443 94.629 109.334 94.5565 109.249C94.5444 109.231 94.5323 109.219 94.5202 109.2C94.3327 108.988 94.0787 108.994 93.8549 108.994C93.5404 108.994 91.0729 108.994 91.0729 108.994C90.7161 108.994 90.4258 109.285 90.4258 109.643V112.051C90.4258 112.409 90.7161 112.7 91.0729 112.7H91.1394H91.2059H93.4134V113.665H91.0729C90.7161 113.665 90.4258 113.956 90.4258 114.314C90.4258 114.671 90.7161 114.963 91.0729 114.963H93.8549H93.9275H94.0605C94.4174 114.963 94.7077 114.671 94.7077 114.314V112.051C94.7077 111.705 94.4416 111.426 94.1029 111.408V111.402H93.994H93.7219H91.72V110.31H94.0605V110.31Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2267 108.994H95.8581C95.5012 108.994 95.2109 109.285 95.2109 109.643C95.2109 110.001 95.5012 110.292 95.8581 110.292H96.9527V114.289C96.9527 114.647 97.243 114.938 97.5998 114.938C97.9567 114.938 98.247 114.647 98.247 114.289V110.292H99.2267C99.5835 110.292 99.8738 110.001 99.8738 109.643C99.8738 109.279 99.5896 108.994 99.2267 108.994Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4075 110.85C74.4075 109.831 73.5789 109 72.5629 109H70.6881C70.6639 109 70.6457 108.994 70.6276 108.994C70.2708 108.994 69.9805 109.285 69.9805 109.643V114.289C69.9805 114.647 70.2708 114.938 70.6276 114.938C70.9844 114.938 71.2747 114.647 71.2747 114.289V112.7H71.7343L73.204 114.678C73.4157 114.963 73.8209 115.023 74.1112 114.805C74.3954 114.593 74.4559 114.186 74.2382 113.895L73.2403 112.567C73.9237 112.3 74.4075 111.627 74.4075 110.85ZM72.5629 111.475H71.2687V110.213H72.5629C72.9076 110.213 73.1919 110.498 73.1919 110.844C73.1919 111.196 72.9076 111.475 72.5629 111.475Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.868 109H105.993C105.975 109 105.95 108.994 105.932 108.994C105.575 108.994 105.285 109.285 105.285 109.643V114.289C105.285 114.647 105.575 114.938 105.932 114.938C106.289 114.938 106.579 114.647 106.579 114.289V112.7H107.874C108.89 112.7 109.718 111.869 109.718 110.85C109.718 109.825 108.89 109 107.868 109ZM107.868 111.475H106.573V110.213H107.868C108.212 110.213 108.497 110.498 108.497 110.844C108.497 111.196 108.218 111.475 107.868 111.475Z",
    fill: "#BFBFBF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9006 155.834L67.4503 144.5L57 155.834H63.2048V165.5H71.8113V155.834H77.9006Z",
    fill: "url(#paint1_linear_454_4593)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.901 155.834L102.45 144.5L92 155.834H98.2048V165.5H106.811V155.834H112.901Z",
    fill: "url(#paint2_linear_454_4593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_4593",
    x1: 86,
    y1: 2.5,
    x2: 86,
    y2: 247.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.938965
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993906,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_454_4593",
    x1: 67.3359,
    y1: 144.5,
    x2: 67.3359,
    y2: 165.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83838",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83838",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_454_4593",
    x1: 102.336,
    y1: 144.5,
    x2: 102.336,
    y2: 165.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83838",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83838",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_4593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 81,
    fill: "white",
    transform: "translate(59.9492 165.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotHelp);
export default __webpack_public_path__ + "static/media/spot-help.ac2f69820751f00f8ce71da911e55066.svg";
export { ForwardRef as ReactComponent };